/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {Block} from 'baseui/block'
import {Button} from 'baseui/button'
import {StyledLink} from 'baseui/link'
import {ParagraphSmall} from 'baseui/typography'
import React, {useState} from 'react'
import {useLocation} from 'react-router-dom'
import {colors, copyright} from '../../utils/config'
import CopyrightModal from './copyright-modal'

const currentYear = new Date().getFullYear()

const Footer = ({alignCopyright, night}) => {
  const [isTOSModalOpen, setIsTOSModalOpen] = useState(false)
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false)

  const toggleTOSModal = () => {
    setIsTOSModalOpen(state => !state)
  }

  const togglePrivacyModal = () => {
    setIsPrivacyModalOpen(state => !state)
  }

  let location = useLocation()

  const linkStyle = {
    backgroundColor: 'transparent',
    color: night ? colors.yellow300 : colors.yellow700,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    textDecoration: 'underline',
    ':hover': {
      backgroundColor: 'transparent',
    },
  }

  if (location.pathname.match('/play')) {
    return null
  }

  return (
    <Block
      $as="footer"
      overrides={{
        Block: {
          style: ({$theme}) => ({
            backgroundColor: night ? '#0f938c' : '#a9dfa0',
            paddingLeft: alignCopyright === 'left' ? 0 : $theme.sizing.scale800,
            paddingRight: alignCopyright === 'left' ? 0 : $theme.sizing.scale800,
            marginBottom: $theme.sizing.scale1600,
            [$theme.media.small]: {
              marginBottom: 0,
            },
          }),
        },
      }}
    >
      <ParagraphSmall
        overrides={{
          Block: {
            style: ({$theme}) => ({
              color: night ? $theme.colors.primary100 : $theme.colors.primary600,
              textAlign: alignCopyright,
            }),
          },
        }}
      >
        Copyright &copy; {currentYear},{' '}
        <StyledLink
          href={copyright.url}
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          {copyright.name}
        </StyledLink>{' '}
        All Rights Reserved. Read our{' '}
        <Button
          $as={StyledLink}
          onClick={toggleTOSModal}
          overrides={{
            BaseButton: {
              style: linkStyle,
            },
          }}
        >
          Terms and Conditions
        </Button>{' '}
        and{' '}
        <Button
          $as={StyledLink}
          onClick={togglePrivacyModal}
          overrides={{
            BaseButton: {
              style: linkStyle,
            },
          }}
        >
          Privacy Policy
        </Button>
        .
      </ParagraphSmall>
      <CopyrightModal
        isModalOpen={isTOSModalOpen}
        toggleModal={toggleTOSModal}
        content="terms-and-conditions"
      />
      <CopyrightModal
        isModalOpen={isPrivacyModalOpen}
        toggleModal={togglePrivacyModal}
        content="privacy-policy"
      />
    </Block>
  )
}

export default Footer
